import { emCalc } from './utilities';

export const breakpoints = {
  // Numerical values will result in a min-width query
  small: 0,
  medium: 321,
  large: 641,
  xlarge: 769,
  xxlarge: 1201,
  // String values will be used as is
  //tallPhone: '(max-width: 360px) and (min-height: 740px)'
}

const mq = Object.keys(breakpoints).reduce(
  (accumulator, label) => {
    let prefix =
      typeof breakpoints[label] === 'string'
        ? ''
        : 'min-width:';
    let suffix =
      typeof breakpoints[label] === 'string' ? '' : ''; // previously px
    accumulator[label] = cls => `
        @media (${prefix + emCalc(breakpoints[label]) + suffix}) {
          ${cls};
        }
      `;
    return accumulator
  },
  {}
)

export default mq;